import { useGetCTMWebformDataOnMount } from '@user/store/webForm/hooks'
import { NameValue } from '../../../NameValueList'
import { useCallback, useEffect, useState } from 'react'
import { WebformDTO } from '@user/store/webForm/typings'

type Props = {
  webFormCallTrackingEventId?: string | null
}

export function useData(props: Props) {
  const { webFormCallTrackingEventId } = props
  const [nameValueList, setNameValueList] = useState<NameValue[]>([])

  const { status, webformData } = useGetCTMWebformDataOnMount(
    webFormCallTrackingEventId,
  )

  const mapWebformDataToNameValueList = useCallback(
    (webformData: WebformDTO) => {
      const list: NameValue[] = []
      list.push({ name: 'Name', value: webformData.name })
      list.push({ name: 'Email', value: webformData.email })
      list.push({ name: 'Phone', value: webformData.phone })
      webformData.customFields.map((item) =>
        list.push({ name: item.label, value: item.value }),
      )
      return list
    },
    [],
  )

  useEffect(() => {
    if (webformData) {
      setNameValueList(mapWebformDataToNameValueList(webformData))
    } else {
      setNameValueList([])
    }
  }, [mapWebformDataToNameValueList, webformData])

  return { status, nameValueList, webformData }
}
